import { render, staticRenderFns } from "./HomeworksWidget.vue?vue&type=template&id=37a356da"
import script from "./HomeworksWidget.vue?vue&type=script&lang=js"
export * from "./HomeworksWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports